import { render, staticRenderFns } from "./shortMessageDialogMassHair.vue?vue&type=template&id=7bb47538&scoped=true&"
import script from "./shortMessageDialogMassHair.vue?vue&type=script&lang=js&"
export * from "./shortMessageDialogMassHair.vue?vue&type=script&lang=js&"
import style0 from "./shortMessageDialogMassHair.vue?vue&type=style&index=0&id=7bb47538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb47538",
  null
  
)

export default component.exports